import React from 'react'
import Footer from 'src/views/website/layouts/Footer'
import Header from 'src/views/website/layouts/Header'

const PublicLayout = ({children}) => {
  return (
    <>
    <Header />
    {children}
    <Footer />
    </>
  )
}

export default PublicLayout